// removed by extract-text-webpack-plugin
module.exports = {"button":"general__button___1RnQ0 borderRadius-s cursor-pointer fontSize-xs paddingLeftRight-xxs transitionDuration-m userSelect-none","buttonDefault":"general__buttonDefault___1EJno c-white bg-black bg-white--hover c-slate--hover fill-white fill-slate--hover","buttonActive":"general__buttonActive___1W2UL bg-snow--d--hover bg-white c-black--hover fill-black fill-black--hover"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-card/CardAction/style/general.css
// module id = 125
// module chunks = 0 1